window.ttx = window.ttx || {};
ttx.refer = {};

// 缓存已加载的参照信息
ttx.refer._cache = {};

/**
 * 根据参照 code 获取参照定义信息
 * @param {string} code - 参照编码
 * @param {function} callback - callback(err, referDef)
 */
ttx.refer.getReferDef = function (code, callback) {
    if (!code) {
        callback(new Error('参照编码不能为空'));
        return;
    }
    // 检查缓存
    if (ttx.refer._cache[code]) {
        callback(null, ttx.refer._cache[code]);
        return;
    }
    ttx.ajax.xhrUtil({
        url: '/api/refer/code',
        method: 'get',
        data: { code: code },
        success: function (res) {
            if (res && res.code === 200 && res.data) {
                ttx.refer._cache[code] = res.data;
                callback(null, res.data);
            } else {
                callback(new Error((res && res.message) || '参照不存在'));
            }
        },
        fail: function (err) {
            callback(err || new Error('获取参照信息失败'));
        }
    });
};

/**
 * 加载参照远程组件并获取组件类
 * @param {object} control - 控件配置（含 refCode）
 * @param {function} callback - callback(err, ReferComponent)
 */
ttx.refer.loadComponent = function (control, callback) {
    var refCode = control && control.refCode;
    if (!refCode) {
        callback(new Error('控件未配置参照类型'));
        return;
    }
    ttx.refer.getReferDef(refCode, function (err, referDef) {
        if (err) {
            callback(err);
            return;
        }
        if (!referDef.scriptUrl) {
            callback(new Error('参照未配置远程组件地址'));
            return;
        }
        // 检查全局是否已注册该组件（参照组件挂载到 window 上）
        var globalName = 'ReferComponent_' + refCode;
        if (window[globalName]) {
            callback(null, window[globalName]);
            return;
        }
        // 动态加载 JS
        tx.loadJS(referDef.scriptUrl, function () {
            if (window[globalName]) {
                callback(null, window[globalName]);
            } else {
                callback(new Error('参照组件加载失败：未找到 ' + globalName));
            }
        }, function () {
            callback(new Error('参照脚本加载失败: ' + referDef.scriptUrl));
        });
    });
};
